export function isLocalhost() {
    if (!window) {
        return null;
    }
    return (
        window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );
}

/**
 * Detects if the current device is a mobile device
 * @returns {boolean} true if mobile device, false otherwise
 */
export const isMobileDevice = () => {
    return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) ||
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0
    );
};
